export const ERROR_TYPES = {
    INVALID_CONTENT_REQUEST: "ERROR_INVALID_CONTENT_REQUEST",
};
